// import crypto from 'crypto';
// const Twig = require('twig');
import Twig from "twig";

// Time to Decimal
Twig.extendFilter("timeToDecimal", function (value) {
    if (!value) return 0;
    const [hours, minutes] = value.split(":").map(Number);
    return hours + minutes / 60;
});

// Decimal to Time
Twig.extendFilter("decimalToTime", function (value) {
    let isNegative = value < 0;
    value = Math.abs(parseFloat(value));
    let hours = Math.floor(value);
    let minutes = Math.round((value - hours) * 60);
    if (minutes === 60) {
        hours++;
        minutes = 0;
    }
    let result = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    return isNegative ? `-${result}` : result;
});

// Decimal to Time with seconds
Twig.extendFilter("decimalToTimeSeconds", function (value) {
    let hours = Math.floor(value);
    let minutesDecimal = (value - hours) * 60;
    let minutes = Math.floor(minutesDecimal);
    let seconds = Math.round((minutesDecimal - minutes) * 60);
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
});

// Time in Interval
Twig.extendFilter("timeInInterval", function (time, date, start, end) {
    let dateTime = new Date(`${date}T${time}`);
    dateTime.setMinutes(dateTime.getMinutes() - 1);
    return dateTime >= new Date(start) && dateTime <= new Date(end);
});

// Difference in Hours
Twig.extendFilter("differenceInHours", function (start, end) {
    let startDate = new Date(start);
    let endDate = new Date(end);
    if (endDate < startDate) {
        endDate.setDate(endDate.getDate() + 1);
    }
    return Math.abs((endDate - startDate) / 3600000);
});

// Reduce by Column
Twig.extendFilter("reduceByColumn", function (array, column) {
    return array.reduce((acc, item) => {
        acc[item[column]] = acc[item[column]] || [];
        acc[item[column]].push(item);
        return acc;
    }, {});
});

// Reduce by Two Columns
Twig.extendFilter("reduceByTwoColumns", function (array, col1, col2) {
    return array.reduce((acc, item) => {
        acc[item[col1]] = acc[item[col1]] || {};
        acc[item[col1]][item[col2]] = acc[item[col1]][item[col2]] || [];
        acc[item[col1]][item[col2]].push(item);
        return acc;
    }, {});
});

// Reduce by Three Columns
Twig.extendFilter("reduceByThreeColumns", function (array, col1, col2, col3) {
    return array.reduce((acc, item) => {
        acc[item[col1]] = acc[item[col1]] || {};
        acc[item[col1]][item[col2]] = acc[item[col1]][item[col2]] || {};
        acc[item[col1]][item[col2]][item[col3]] = acc[item[col1]][item[col2]][item[col3]] || [];
        acc[item[col1]][item[col2]][item[col3]].push(item);
        return acc;
    }, {});
});

// Hours Intersect
Twig.extendFilter("hoursIntersect", function (start1, end1, start2, end2) {
    let s1 = new Date(start1).getTime();
    let e1 = new Date(end1).getTime();
    let s2 = new Date(start2).getTime();
    let e2 = new Date(end2).getTime();
    let overlap = Math.max(0, Math.min(e1, e2) - Math.max(s1, s2));
    return overlap / 3600000;
});

// Encrypt/Decrypt
Twig.extendFilter("encryptDecrypt", function (text, action) {
    // const crypto = require('crypto');
    const secretKey = 'This is my secret key';
    const secretIV = 'This is my secret iv';
    const key = crypto.createHash('sha256').update(secretKey).digest('hex').substring(0, 32);
    const iv = crypto.createHash('sha256').update(secretIV).digest('hex').substring(0, 16);

    if (action === 'encrypt') {
        let cipher = crypto.createCipheriv('aes-256-cbc', Buffer.from(key), iv);
        let encrypted = cipher.update(text);
        encrypted = Buffer.concat([encrypted, cipher.final()]);
        return encrypted.toString('base64');
    } else if (action === 'decrypt') {
        let decipher = crypto.createDecipheriv('aes-256-cbc', Buffer.from(key), iv);
        let decrypted = decipher.update(Buffer.from(text, 'base64'));
        decrypted = Buffer.concat([decrypted, decipher.final()]);
        return decrypted.toString();
    }
    return null;
});

// MD5 Filter
Twig.extendFilter("md5", function (value) {
    return crypto.createHash('md5').update(value).digest('hex');
});

// JSON Decode Filter
Twig.extendFilter("json_decode", function (value) {
    return JSON.parse(value);
});

// Calculate Chilean DV
Twig.extendFilter("chilean_dv", function (rut) {
    let s = 1;
    for (let m = 0; rut !== 0; rut = Math.floor(rut / 10)) {
        s = (s + (rut % 10) * (9 - (m++ % 6))) % 11;
    }
    return s ? String.fromCharCode(s + 47) : 'K';
});

// Save in Session
Twig.extendFilter("save", function (value) {
    global.custom_endpoint_result = value;
    return true;
});

export default Twig;